<template>
  <div class="space-y-1">
    <slot />
  </div>
</template>
